import type { ReactElement, ReactNode } from 'react';
import type { SvgIconComponent } from '@/types';

export enum IconLinkListIconSize {
    Full = 'full',
    Medium = 'medium',
    Small = 'small',
}

export interface ContentProps {
    children: ReactNode;
    error?: boolean;
    destructive?: boolean;
    highlight?: boolean;
    subdued?: boolean;
}

export interface InteriorProps {
    icon: ReactElement | SvgIconComponent;
    iconSize?: IconLinkListIconSize;
    label?: string;
}

// TODO: Should include a11y props
interface ButtonSubset {
    disabled?: boolean;
    pressed?: boolean;
    onAction(): void;
}

interface LinkSubset {
    url: string;
    openNewTab?: boolean;
}

export type ButtonProps = InteriorProps & ButtonSubset;
export type LinkProps = InteriorProps & LinkSubset;
